import DynamicParams from './DynamicParams';

export default DynamicParams;
